$(".slick-arrow-c").click(function() {
  console.log("arrow mobile~")
   var id = $(this).attr('id');
  var box = "",x;
  var boxchildWidth = 0;
   console.log("id", id)
  if (id== "slickNextC" || id == "slickPrevC"){
      box = $("#nav-lens-color");
    
  }else if(id== "slickPrev-cc632c33-0df3-40de-9eb6-0496020a0e96" || id == "slickNext-cc632c33-0df3-40de-9eb6-0496020a0e96"){
       box = $("#grid-cc632c33-0df3-40de-9eb6-0496020a0e96");
     boxchildWidth = $("#grid-cc632c33-0df3-40de-9eb6-0496020a0e96 div:first-child").width()
  }else if(id== "slickPrev-15d9e7c6-cf97-474a-84c6-6d209024cf14" || id == "slickNext-15d9e7c6-cf97-474a-84c6-6d209024cf14"){
       box = $("#grid-15d9e7c6-cf97-474a-84c6-6d209024cf14");
      boxchildWidth = $("#grid-15d9e7c6-cf97-474a-84c6-6d209024cf14 div:first-child").width()
  }else if(id== "slickPrev-1053b182-4f07-446d-817e-4c192c3303d2" || id == "slickNext-1053b182-4f07-446d-817e-4c192c3303d2"){
       box = $("#grid-c1053b182-4f07-446d-817e-4c192c3303d2"); 
     boxchildWidth = $("#grid-c1053b182-4f07-446d-817e-4c192c3303d2 div:first-child").width()
  }else if(id== "slickPrev-a61f4955-f746-473e-9e72-115964e6e330" || id == "slickNext-a61f4955-f746-473e-9e72-115964e6e330"){
       box = $("#grid-a61f4955-f746-473e-9e72-115964e6e330");
       boxchildWidth = $("#grid-a61f4955-f746-473e-9e72-115964e6e330 div:first-child").width()
  }else if(id== "slickPrev-538f0135-2ade-46b4-9f92-3cc11a912b4a" || id == "slickNext-538f0135-2ade-46b4-9f92-3cc11a912b4a"){
       box = $("#grid-538f0135-2ade-46b4-9f92-3cc11a912b4a");
     boxchildWidth = $("#grid-538f0135-2ade-46b4-9f92-3cc11a912b4a div:first-child").width()
  }else if(id== "slickPrev-377f1e5e-cfd3-4879-9dd7-2cd66c3f4bd0" || id == "slickNext-377f1e5e-cfd3-4879-9dd7-2cd66c3f4bd0"){
       box = $("#grid-377f1e5e-cfd3-4879-9dd7-2cd66c3f4bd0");
     boxchildWidth = $("grid-377f1e5e-cfd3-4879-9dd7-2cd66c3f4bd0 div:first-child").width()
  }else if(id== "slickPrev-2ff2b5e3-0d64-47bb-83ba-0dc4441f4a47" || id == "slickNext-2ff2b5e3-0d64-47bb-83ba-0dc4441f4a47"){
       box = $("#grid-2ff2b5e3-0d64-47bb-83ba-0dc4441f4a47");
     boxchildWidth = $("grid-2ff2b5e3-0d64-47bb-83ba-0dc4441f4a47 div:first-child").width()
  }else if(id== "slickPrev-23fab18b-f04f-494e-a75d-4a96494f399f" || id == "slickNext-23fab18b-f04f-494e-a75d-4a96494f399f"){
       box = $("#grid-23fab18b-f04f-494e-a75d-4a96494f399f");
     boxchildWidth = $("#grid-23fab18b-f04f-494e-a75d-4a96494f399f div:first-child").width()
  }else if(id== "slickPrev-a3cc07d7-332a-4f0b-a075-a372d9a86730" || id == "slickNext-a3cc07d7-332a-4f0b-a075-a372d9a86730"){
       box = $("#grid-a3cc07d7-332a-4f0b-a075-a372d9a86730");
     boxchildWidth = $("#grid-a3cc07d7-332a-4f0b-a075-a372d9a86730 div:first-child").width()
  }else if(id== "slickPrev-c346ef3a-befa-46ed-8fe2-08a23d2cb2d8" || id == "slickNext-c346ef3a-befa-46ed-8fe2-08a23d2cb2d8"){
       box = $("#grid-c346ef3a-befa-46ed-8fe2-08a23d2cb2d8");
     boxchildWidth = $("#grid-c346ef3a-befa-46ed-8fe2-08a23d2cb2d8 div:first-child").width()
  }else if(id== "slickPrev-79e0fb6d-5234-4196-8ea0-0d382b0565e4" || id == "slickNext-79e0fb6d-5234-4196-8ea0-0d382b0565e4"){
       box = $("#grid-79e0fb6d-5234-4196-8ea0-0d382b0565e4");
     boxchildWidth = $("#grid-79e0fb6d-5234-4196-8ea0-0d382b0565e4 div:first-child").width()
  }else if(id== "slickPrev-f5512874-74b8-432b-9599-9872cb7ee7e2" || id == "slickNext-f5512874-74b8-432b-9599-9872cb7ee7e2"){
       box = $("#grid-f5512874-74b8-432b-9599-9872cb7ee7e2");
     boxchildWidth = $("#grid-f5512874-74b8-432b-9599-9872cb7ee7e2 div:first-child").width()
  }else if(id== "slickPrev-9c1ec077-6473-404c-a736-d0b83bde1c29" || id == "slickNext-9c1ec077-6473-404c-a736-d0b83bde1c29"){
       box = $("#grid-9c1ec077-6473-404c-a736-d0b83bde1c29");
     boxchildWidth = $("#grid-9c1ec077-6473-404c-a736-d0b83bde1c29 div:first-child").width()
  }else if(id== "slickPrev-61a00119-98da-4625-a650-87bef89703f0" || id == "slickNext-61a00119-98da-4625-a650-87bef89703f0"){
       box = $("#grid-61a00119-98da-4625-a650-87bef89703f0");
     boxchildWidth = $("#grid-61a00119-98da-4625-a650-87bef89703f0 div:first-child").width()
  }else if(id== "slickPrev-82835e69-0d14-495d-8222-2c2b3ceb7c56" || id == "slickNext-82835e69-0d14-495d-8222-2c2b3ceb7c56"){
       box = $("#grid-82835e69-0d14-495d-8222-2c2b3ceb7c56");
     boxchildWidth = $("#grid-82835e69-0d14-495d-8222-2c2b3ceb7c56 div:first-child").width()
  }else if(id== "slickPrev-7e8c0e52-340a-4ed6-aa8d-cf551c6f3793" || id == "slickNext-7e8c0e52-340a-4ed6-aa8d-cf551c6f3793"){
       box = $("#grid-7e8c0e52-340a-4ed6-aa8d-cf551c6f3793");
     boxchildWidth = $("#grid-7e8c0e52-340a-4ed6-aa8d-cf551c6f3793 div:first-child").width()
  }else if(id== "slickPrev-6cd03912-5949-4979-86df-c80668d563c9" || id == "slickNext-6cd03912-5949-4979-86df-c80668d563c9"){
       box = $("#grid-6cd03912-5949-4979-86df-c80668d563c9");
     boxchildWidth = $("#grid-6cd03912-5949-4979-86df-c80668d563c9 div:first-child").width()
  }else if(id== "slickPrev-3666b1b4-ff35-4bac-a0cd-ab92817b4928" || id == "slickNext-3666b1b4-ff35-4bac-a0cd-ab92817b4928"){
       box = $("#grid-3666b1b4-ff35-4bac-a0cd-ab92817b4928");
     boxchildWidth = $("#grid-3666b1b4-ff35-4bac-a0cd-ab92817b4928 div:first-child").width()
  }else if (id== "slickPrev-1640050993c35954c8" || id == "slickNext-1640050993c35954c8"){
     box = $("#sps-products-1640050993c35954c8");
     boxchildWidth = $("#sps-products-1640050993c35954c8 div:first-child").width()
  }else if (id== "slickPrev-cross-cart" || id == "slickNext-cross-cart"){
     box = $("#grid-cross-cart");
     boxchildWidth = $("#grid-cross-cart div:first-child").width()
  }else if (id== "slickPrev-review" || id == "slickNext-review"){
     box = $("#grid-review");
     boxchildWidth = $("#grid-review div:first-child").width()
  }

  console.log("box", box)
  console.log("box.width", box.width())
  console.log("boxchildWidth", boxchildWidth)

 // boxWidth = box.children[0].clientWidth
  //console.log("boxWidth", boxWidth)
  
  if ($(this).hasClass("slick-next")) {
   // x = (box.width() -  (box.width() - 259.8)) + box.scrollLeft();
    if(boxchildWidth != 0){
     x = (boxchildWidth + 20) + box.scrollLeft();
    console.log("x", x)
    }else{
     x = ((box.width() / 2) - 10) + box.scrollLeft();
    } 
    box.animate({
      scrollLeft: x,
    })

      
  } else {
    //x = ((box.width() / 2)) - box.scrollLeft();
      if(boxchildWidth != 0){
     x = (boxchildWidth + 20) - box.scrollLeft();
    console.log("x", x)
    }else{
     x = ((box.width() / 2) - 10) - box.scrollLeft();
    }
    box.animate({
      scrollLeft: -x,
    })
  }
})